import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const EmptyTasksIcon = (props: IconProps) => (
  <Icon width="231px" height="240px" viewBox="0 0 231 240" {...props}>
    <ellipse
      cx="115.357"
      cy="120.357"
      rx="115.357"
      ry="115.357"
      fill="#ECF9EF"
      fillOpacity="0.2"
    />
    <path
      d="M100.715 38.0723C120.056 38.0723 138.265 43.5607 151.981 53.5518C158.662 58.4177 163.921 64.0963 167.602 70.4336C171.418 77.0056 173.359 83.9996 173.359 91.2139C173.359 98.428 171.42 105.422 167.602 111.994C163.922 118.33 158.662 124.008 151.981 128.876C138.265 138.867 120.054 144.355 100.715 144.355C88.3402 144.355 76.1207 142.042 65.3751 137.661V137.66C63.1955 136.772 60.7323 136.865 58.6154 137.916L34.4318 153.124V153.125C34.1876 153.278 33.912 153.359 33.6329 153.359C33.2339 153.359 32.8516 153.194 32.5636 152.891V152.892L32.548 152.876C32.054 152.343 32.0063 151.569 32.4386 150.98L45.3107 133.376C46.775 130.141 46.0126 126.332 43.3907 123.872C38.5356 119.318 34.7488 114.25 32.1417 108.809C29.4429 103.17 28.0714 97.2492 28.0714 91.2139C28.0714 83.9996 30.0112 77.0058 33.8292 70.4336L34.1788 69.8418C37.8387 63.7424 42.9773 58.2672 49.4503 53.5518C63.1663 43.5608 81.3743 38.0723 100.715 38.0723ZM100.715 39.7666C81.9978 39.7666 64.4076 44.9919 51.0773 54.4668L50.4454 54.9209C43.9394 59.6596 38.8462 65.167 35.2931 71.2842L35.2921 71.2832C31.6205 77.6059 29.7648 84.3089 29.7648 91.2139C29.7648 96.9901 31.0765 102.663 33.6691 108.075C36.178 113.315 39.8367 118.215 44.548 122.634C47.7183 125.607 48.6305 130.236 46.8175 134.152L46.8185 134.153L46.8048 134.185L46.7833 134.233L46.7511 134.276L34.4357 151.117L57.756 136.453L57.7677 136.445L57.797 136.428L57.8116 136.42L57.8273 136.412C59.2273 135.71 60.7543 135.357 62.2814 135.357C63.5488 135.357 64.8172 135.6 66.0138 136.089L66.2599 136.188C76.7366 140.42 88.6435 142.659 100.713 142.659C119.727 142.659 137.579 137.269 150.983 127.505C157.489 122.766 162.584 117.26 166.136 111.143C169.807 104.822 171.662 98.1173 171.662 91.2139C171.662 84.3105 169.806 77.6062 166.136 71.2852C162.583 65.168 157.489 59.6615 150.983 54.9229C137.579 45.1591 119.729 39.7666 100.715 39.7666Z"
      fill="#D9F2E0"
      stroke="#D9F2E0"
    />
    <path
      d="M156.625 107.37C158.428 103.309 159.421 98.9153 159.526 94.455C159.572 92.543 161.094 90.9977 163.003 90.9448C165.269 90.8817 167.019 92.9182 166.627 95.1543C165.797 99.891 163.96 104.431 161.208 108.435C158.433 112.472 154.938 111.172 156.625 107.37Z"
      fill="#D9F2E0"
    />
    <path
      d="M163.33 87.7126C160.98 88.3062 158.593 86.8393 158.086 84.465C157.706 82.6929 157.178 80.9275 156.494 79.186C153.108 70.5622 146.553 64.1319 138.699 60.7018C132.09 57.8159 138.968 54.0583 146.835 57.4952C154.691 60.9253 161.244 67.3556 164.63 75.9794C165.519 78.2411 166.144 80.5403 166.522 82.8447C166.885 85.0501 165.494 87.1668 163.33 87.7126Z"
      fill="#D9F2E0"
    />
    <path
      d="M144.897 109.5C130.731 109.5 117.387 113.52 107.331 120.845C102.738 124.189 99.0599 128.06 96.3916 132.364L95.8711 133.23C93.0694 138.055 91.6427 143.193 91.6426 148.493C91.6426 153.628 92.9801 158.61 95.6123 163.304L95.8711 163.757C98.572 168.408 102.432 172.574 107.331 176.143C117.387 183.467 130.732 187.487 144.897 187.487C153.962 187.487 162.914 185.792 170.789 182.582C172.344 181.949 174.101 182.012 175.612 182.759L193.294 193.879H193.295C193.494 194.004 193.72 194.071 193.95 194.071C194.279 194.071 194.593 193.936 194.828 193.689L194.835 193.682L194.842 193.675C195.246 193.238 195.286 192.601 194.932 192.118L185.529 179.258C184.489 176.947 185.034 174.23 186.907 172.473C190.468 169.132 193.248 165.413 195.162 161.418C197.144 157.277 198.151 152.927 198.151 148.493C198.151 143.193 196.726 138.055 193.923 133.23C191.222 128.578 187.362 124.414 182.463 120.845L181.511 120.168C171.572 113.273 158.622 109.5 144.897 109.5ZM144.897 111.008C158.777 111.008 171.802 114.944 181.577 122.063C186.322 125.519 190.032 129.532 192.62 133.987C195.294 138.591 196.644 143.469 196.645 148.493C196.645 152.696 195.69 156.825 193.803 160.765C191.976 164.579 189.311 168.15 185.877 171.371C183.517 173.584 182.837 177.03 184.187 179.946L184.186 179.947L184.195 179.97L184.218 180.019L184.249 180.062L192.84 191.81L176.382 181.46L176.376 181.456L176.37 181.453L176.349 181.44L176.334 181.432L176.319 181.424C175.276 180.901 174.138 180.639 173.001 180.639C172.057 180.639 171.112 180.819 170.221 181.184L170.054 181.252C162.407 184.342 153.713 185.979 144.898 185.979C131.019 185.979 117.994 182.043 108.219 174.923C103.474 171.467 99.7621 167.454 97.1758 162.999H97.1748C94.5013 158.396 93.1523 153.516 93.1523 148.493C93.1524 143.47 94.5035 138.591 97.1758 133.988V133.987C99.7634 129.533 103.475 125.52 108.219 122.064C117.994 114.944 131.018 111.008 144.897 111.008ZM170.315 181.415L170.406 181.639L170.315 181.415Z"
      fill="#D9F2E0"
      stroke="#D9F2E0"
    />
    <path
      d="M185.781 160.307C187.099 157.337 187.825 154.124 187.902 150.863C187.936 149.465 189.049 148.335 190.444 148.296C192.101 148.25 193.381 149.739 193.095 151.374C192.487 154.838 191.144 158.158 189.132 161.085C187.103 164.037 184.547 163.087 185.781 160.307Z"
      fill="#D9F2E0"
    />
    <path
      d="M190.683 145.934C188.965 146.368 187.22 145.295 186.849 143.559C186.571 142.263 186.185 140.972 185.685 139.699C183.209 133.392 178.415 128.69 172.672 126.182C167.839 124.072 172.869 121.324 178.622 123.837C184.366 126.346 189.158 131.048 191.635 137.354C192.284 139.008 192.741 140.689 193.018 142.374C193.283 143.987 192.266 145.534 190.683 145.934Z"
      fill="#D9F2E0"
    />
    <rect
      x="169.286"
      y="26.4277"
      width="36.4286"
      height="12.8571"
      rx="6.42857"
      fill="#D9F2E0"
    />
    <ellipse
      cx="176.428"
      cy="32.8557"
      rx="2.14286"
      ry="2.14286"
      fill="#B3E5C0"
    />
    <ellipse
      cx="183.571"
      cy="32.8557"
      rx="2.14286"
      ry="2.14286"
      fill="#B3E5C0"
    />
    <ellipse
      cx="190.714"
      cy="32.8557"
      rx="2.14285"
      ry="2.14286"
      fill="#B3E5C0"
    />
    <ellipse
      cx="197.857"
      cy="32.8557"
      rx="2.14286"
      ry="2.14286"
      fill="#B3E5C0"
    />
    <rect
      x="12.8572"
      y="183.572"
      width="36.4286"
      height="12.8571"
      rx="6.42857"
      fill="#D9F2E0"
    />
    <ellipse cx="20" cy="190" rx="2.14286" ry="2.14285" fill="#B3E5C0" />
    <ellipse cx="27.1429" cy="190" rx="2.14286" ry="2.14285" fill="#B3E5C0" />
    <ellipse cx="34.2858" cy="190" rx="2.14286" ry="2.14285" fill="#B3E5C0" />
    <ellipse cx="41.4286" cy="190" rx="2.14286" ry="2.14285" fill="#B3E5C0" />
    <mask
      id="mask0_4880_32700"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="189"
      y="49"
      width="38"
      height="38"
    >
      <ellipse
        cx="208.464"
        cy="67.7494"
        rx="18.5307"
        ry="18.5307"
        fill="#B94C24"
      />
    </mask>
    <g mask="url(#mask0_4880_32700)">
      <rect
        x="184.004"
        y="42.1777"
        width="73.3816"
        height="70.046"
        fill="#B3E5C0"
      />
      <path
        d="M206.913 83.9935C202.537 84.2647 196.884 82.8206 194.062 91.0952C191.9 106.017 188.199 163.592 188.199 163.592L230.016 163.903C230.016 163.903 228.298 113.216 223.065 91.0857C221.624 84.988 218.365 86.8009 216.676 85.4924C213.87 84.3099 210.637 83.7604 206.917 83.9911L206.913 83.9935Z"
        fill="#40BF62"
      />
      <path
        d="M200.929 96.7746C200.929 96.7746 189.461 91.286 193.245 83.1089C197.029 74.9319 226.229 78.1794 226.049 85.4024C225.868 92.623 211.811 97.7405 211.811 97.7405L200.931 96.7746H200.929Z"
        fill="#40BF62"
      />
      <path
        d="M199.77 70.557C199.77 70.557 198.188 65.2326 199.549 61.6805C201.264 57.2125 209.428 52.2449 212.105 53.4892C214.785 54.7335 210.83 57.5837 212.048 57.9382C213.267 58.2927 214.006 55.4567 214.82 55.9825C218.113 58.1071 215.982 69.2937 215.982 69.2937L204.506 65.8511L199.77 70.557Z"
        fill="#5B5B5B"
      />
      <path
        d="M212.481 85.4822L208.545 89.2317L204.606 85.4822L205.297 76.9863H211.789L212.481 85.4822Z"
        fill="#F9C1AD"
      />
      <path
        d="M215.075 66.8708C214.626 62.8454 211.089 60.5733 207.081 61.0206C203.076 61.4678 200.121 64.4655 200.57 68.4886C200.57 68.4886 200.827 73.6585 200.855 73.9083C201.281 77.7339 206.495 82.0639 209.388 81.7403C212.728 81.3668 216.312 75.1145 215.989 72.2191C215.961 71.9693 215.072 66.8685 215.072 66.8685L215.075 66.8708Z"
        fill="#F9C1AD"
      />
      <path
        d="M201.038 69.4483C201.038 69.4483 200.045 68.9535 199.435 69.9884C198.824 71.0257 199.701 74.5611 201.492 74.3612C203.283 74.1614 201.036 69.4483 201.036 69.4483H201.038Z"
        fill="#F9C1AD"
      />
      <path
        d="M214.885 67.901C214.885 67.901 215.744 67.1991 216.569 68.0746C217.391 68.9525 217.315 72.5926 215.521 72.7924C213.73 72.9923 214.885 67.901 214.885 67.901Z"
        fill="#F9C1AD"
      />
      <g clipPath="url(#clip0_4880_32700)">
        <path
          d="M225.099 88.4933L199.986 92.6563L241.232 114.652L230.67 91.4644C229.696 89.327 227.414 88.1095 225.1 88.4931L225.099 88.4933Z"
          fill="#CEA23E"
        />
      </g>
    </g>
    <mask
      id="mask1_4880_32700"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="60"
      y="177"
      width="41"
      height="41"
    >
      <ellipse
        cx="80.3571"
        cy="197.5"
        rx="20.3571"
        ry="20.3571"
        fill="#B94C24"
      />
    </mask>
    <g mask="url(#mask1_4880_32700)">
      <rect
        x="53.4857"
        y="169.406"
        width="80.6143"
        height="76.95"
        fill="#F3F6D3"
      />
      <path
        d="M73.6423 212.162C73.6423 212.162 67.16 216.582 65.2912 235.602C63.9809 248.925 62.85 253.608 62.85 253.608L66.6704 253.663C66.6704 253.663 74.1389 235.002 74.8147 226.72C75.1319 222.81 73.6423 212.169 73.6423 212.169V212.162Z"
        fill="white"
      />
      <path
        d="M87.5931 211.99C87.5931 211.99 95.1167 214.928 96.7649 235.065C97.8545 248.402 98.9785 253.608 98.9785 253.608L95.1581 253.663C95.1581 253.663 87.6896 235.002 87.0138 226.72C86.6966 222.81 87.6 211.99 87.6 211.99H87.5931Z"
        fill="white"
      />
      <path
        d="M78.642 210.571C76.2008 210.722 73.5113 211.15 72.7596 213.701C72.2562 217.177 73.9182 228.287 71.8149 239.651C68.8564 255.65 69.4909 272.987 69.4909 272.987L92.8203 273.159C92.8203 273.159 93.1168 255.657 90.7239 239.824C89.1033 229.107 90.4481 218.529 88.9378 213.694C88.1448 211.15 84.3312 210.902 83.0348 210.571C81.4694 209.915 80.7177 210.44 78.642 210.571Z"
        fill="white"
      />
      <path
        d="M95.2892 195.599C95.2892 203.695 88.7241 210.26 80.6281 210.26C72.5321 210.26 65.967 203.695 65.967 195.599C65.967 187.503 72.5321 180.938 80.6281 180.938C88.7241 180.938 95.2892 187.503 95.2892 195.599Z"
        fill="#323232"
      />
      <path
        d="M76.1939 201.729C76.1939 201.729 75.6422 198.681 76.6215 196.799C77.849 194.433 81.5108 193.13 84.3313 195.647C86.2967 197.399 85.2623 202.026 85.2623 202.026L79.111 199.412L76.1939 201.723V201.729Z"
        fill="#323232"
      />
      <path
        d="M83.0348 210.571C83.0348 210.571 80.4556 211.936 78.642 210.571L79.0281 205.84H82.6486L83.0348 210.571Z"
        fill="#653D2E"
      />
      <path
        d="M76.9662 201.199C76.9662 201.199 76.449 200.861 76.0421 201.399C75.6422 201.936 75.9111 203.943 76.911 203.943C77.911 203.943 76.9593 201.199 76.9593 201.199H76.9662Z"
        fill="#653D2E"
      />
      <path
        d="M84.7382 201.199C84.7382 201.199 85.2554 200.861 85.6623 201.399C86.0622 201.936 85.8002 203.943 84.7934 203.943C83.7865 203.943 84.7451 201.199 84.7451 201.199H84.7382Z"
        fill="#653D2E"
      />
      <path
        d="M84.9036 200.639C84.9036 198.384 83.083 196.908 80.8349 196.908C78.5868 196.908 76.7662 198.384 76.7662 200.639C76.7662 200.639 76.5869 203.515 76.5869 203.659C76.5869 205.804 79.2143 208.521 80.8349 208.521C82.7106 208.521 85.0829 205.28 85.0829 203.659C85.0829 203.522 84.9036 200.639 84.9036 200.639Z"
        fill="#653D2E"
      />
      <path
        d="M76.8766 205.197C76.8766 205.197 76.9318 205.184 76.9593 205.17L76.8628 204.935C76.8628 204.935 76.8283 204.949 76.8145 204.949C76.3663 205.073 75.8973 204.804 75.7732 204.349C75.6491 203.901 75.918 203.432 76.3732 203.308L76.3111 203.066C75.7249 203.225 75.3732 203.832 75.5319 204.411C75.6905 204.997 76.2973 205.342 76.8835 205.19L76.8766 205.197Z"
        fill="white"
      />
      <path
        d="M84.7519 205.198C84.7519 205.198 84.6899 205.178 84.6554 205.164C84.683 205.171 84.7588 204.936 84.7588 204.936C84.7795 204.936 84.8002 204.95 84.814 204.957C85.2623 205.081 85.7312 204.812 85.8553 204.357C85.9794 203.909 85.7105 203.44 85.2554 203.316L85.3174 203.074C85.9036 203.233 86.2484 203.84 86.0967 204.419C85.9381 205.005 85.3312 205.35 84.745 205.198H84.7519Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_4880_32700">
        <rect
          width="56.0927"
          height="56.1418"
          fill="white"
          transform="matrix(0.882375 0.470547 -0.469399 0.882986 205.875 71.6211)"
        />
      </clipPath>
    </defs>
  </Icon>
);

export default memo(EmptyTasksIcon);
